import { Typography } from '@mui/material';
import { BoxedUrlWithCopy } from 'components';

const ServiceProviderInformation = ({ acsUrl, spEntityId }: { acsUrl: string; spEntityId: string }) => (
  <>
    <Typography variant="h3">Service Provider Metadata</Typography>
    <Typography variant="body2">
      Use this information to configure your identity provider to enable Single Sign-On (SSO) for your firm.
    </Typography>
    <Typography variant="h4" mt={2} gutterBottom>
      Assertion Consumer Service (ACS) URL
    </Typography>
    <BoxedUrlWithCopy url={acsUrl} />
    <Typography variant="h4" mt={2} gutterBottom>
      Service Provider Entity ID
    </Typography>
    <BoxedUrlWithCopy url={spEntityId} />
  </>
);

export default ServiceProviderInformation;
